<template>
  <div>
    <CandidateInterviewVirtualBlank
      v-if="!candidateInterview || isOnlineInterviewBlank"
      :interview-type="'online'"
    />
    <CandidateInterviewRecording v-else-if="isOnlineInterviewRecording" />
    <CandidateInterviewProcessing v-else-if="isOnlineInterviewProcessing" />
    <CandidateInterviewProcessingFailed v-else-if="isOnlineInterviewProcessingFailed" />
    <template v-else-if="showVirtualInterviewPlayer && candidate.interview">
      <InterviewsQuotaExceededCandidate
        v-if="!candidate.quotaWrittenOff
          && candidate.interview.images.length &&
          candidate.interview.images[0].url" :img="candidate.interview.images[0].url"
      />
      <CandidateInterviewVirtual
        v-else-if="showVirtualInterviewPlayer && candidate.interview"
        :candidate="candidate"
        :vacancy="vacancy"
        :are-questions-equal="areQuestionsEqual"
        @play="$emit('online-interview-played')"
      />
    </template>
  </div>
</template>

<script>
import { interviewStatuses } from '../../../enums';
import CandidateInterviewVirtual from '../CandidateInterviewVirtual.vue';
import CandidateInterviewRecording from '../CandidateInterviewRecording.vue';
import CandidateInterviewProcessing from '../CandidateInterviewProcessing.vue';
import CandidateInterviewProcessingFailed from '../CandidateInterviewProcessingFailed.vue';
import InterviewsQuotaExceededCandidate from '../CandidateInterviewHasNotOpened.vue';
import CandidateInterviewVirtualBlank from '../CandidateInterviewBlank.vue';

export default {
  name: 'OnlineInterview',
  components: {
    CandidateInterviewVirtual,
    CandidateInterviewRecording,
    CandidateInterviewProcessing,
    CandidateInterviewProcessingFailed,
    InterviewsQuotaExceededCandidate,
    CandidateInterviewVirtualBlank,
  },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
    interview: {
      type: Object,
      required: true,
    },
    areQuestionsEqual: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      candidateInterview: null,
    };
  },
  computed: {
    isOnlineInterviewBlank() {
      return this.candidateInterview
        && this.interview.status === interviewStatuses.BLANK;
    },
    isOnlineInterviewRecording() {
      return this.candidateInterview
        && this.interview.status === interviewStatuses.RECORDING;
    },
    isOnlineInterviewProcessing() {
      return this.candidateInterview
        && this.interview.status === interviewStatuses.PROCESSING;
    },
    isOnlineInterviewProcessingFailed() {
      return this.candidateInterview
        && this.interview.status === interviewStatuses.PROCESSING_FAILED;
    },
    showVirtualInterviewPlayer() {
      return this.candidateInterview
        && this.interview.status === interviewStatuses.READY;
    },
  },
  created() {
    if (this.interview.status) {
      this.candidateInterview = this.interview;
    }
  },
};
</script>

<style scoped>

</style>
